import React, { ImgHTMLAttributes, useEffect, useState } from 'react';
import { LazyImg, LazyProps } from '../LazyComponent';

export const TRANS_WEBP_STR = 'image_process=format,webp';

// eslint-disable-next-line react-func/max-lines-per-function
export const getOptimizedImgUrl = ({
  src,
  width,
  height,
  quality,
  customOptimize = [],
}: {
  src: string;
  width?: number;
  height?: number;
  quality?: number;
  customOptimize?: string[]; // 相关参数：https://help.aliyun.com/zh/cdn/user-guide/convert-image-formats
}) => {
  const url = new URL(src);
  if (!['static.fuxi.netease.com'].includes(url.hostname)) {
    return src;
  }
  const params = new URLSearchParams(url.search);
  params.delete('image_process');
  let imageProcessStr = `format,webp`;
  if (width) {
    imageProcessStr += `/resize,w_${width}`;
  }
  if (height) {
    imageProcessStr += `/resize,h_${height}`;
  }
  if (quality) {
    imageProcessStr += `/quality,Q_${Math.max(Number(quality || 0), 75)}`;
  }
  params.append('image_process', `${imageProcessStr}${!!customOptimize?.length ? customOptimize.join('/') : ''}`);

  let newSearchParams = '';
  for (const key of params.keys()) {
    if (newSearchParams.length > 0) {
      newSearchParams += '&';
    }
    newSearchParams += key + '=' + params.get(key);
  }
  url.search = newSearchParams;
  return url.toString();
};

export const OptimizedImg: LazyProps<
  ImgHTMLAttributes<HTMLImageElement> & {
    customOptimize?: string[];
    width?: number;
    height?: number;
    quality?: number;
    loading?: 'lazy';
  }
> = props => {
  const {
    src,
    customOptimize = [],
    height,
    width,
    quality,
    loading,
    style = {},
    inViewOptions = { rootMargin: '120px' }, // 在没有专门制定传入默认给 120px 的提前懒加载
    ...rest
  } = props;

  const [imgSrc, setImgSrc] = useState('');

  useEffect(() => {
    const dpr = window.devicePixelRatio || 1;
    let dprAdjustedWidth = undefined;
    if (width) {
      dprAdjustedWidth = Math.round(width * dpr * 100000) / 100000;
    }
    let dprAdjustedHeight = undefined;
    if (height) {
      dprAdjustedHeight = Math.round(height * dpr * 100000) / 100000;
    }

    setImgSrc(
      getOptimizedImgUrl({
        src,
        width: dprAdjustedWidth,
        height: dprAdjustedHeight,
        quality,
        customOptimize,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [src]);

  if (loading === 'lazy') {
    return (
      <LazyImg
        inViewOptions={inViewOptions}
        style={{
          objectFit: 'cover',
          ...style,
        }}
        {...rest}
        src={imgSrc}
      />
    );
  }

  return (
    // eslint-disable-next-line jsx-a11y/alt-text
    <img
      style={{
        objectFit: 'cover',
        ...style,
      }}
      {...rest}
      src={imgSrc}
    />
  );
};
